import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { BsFillEyeFill } from "react-icons/bs";
import {
  FiCalendar,
  FiArrowRight,
  FiCheckCircle,
  FiClock,
  FiXCircle,
  FiCreditCard,
  FiArrowDownLeft,
  FiArrowUpRight,
} from "react-icons/fi";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineReceiptLong,
} from "react-icons/md";

import Invoice from "./Invoice";
import "./invoice.css";
import socket from "../Components/socket";
import { apiRequest } from "../../apiService/allApi";

import "../css/Newhistory.css";


const Transactionhistory = () => {
  const printRef = useRef(null);

  const [show, setShow] = useState(false);
  const [invoiceData, setInvoiceData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);

  const [user, setUser] = useState("");
  const [cardData, setGame] = useState();

  const limit = 50;

  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [Withdrawal, setWithdrawal] = useState();
  const [showBottom, setShowBottom] = useState(false);

  // ========================================
  // INVOICE HANDLERS
  // ========================================

  const handleClose = () => setShow(false);

  const handleShow = (data) => {
    setShow(true);
    setInvoiceData(data);
  };

  // ========================================
  // WITHDRAWAL DETAILS HANDLERS
  // ========================================

  const handleCloseBottom = () => setShowBottom(false);

  const handleShowBottom = (data) => {
    setShowBottom(true);
    setWithdrawal(data);
  };

  // ========================================
  // USER PROFILE API
  // ========================================

  const role = async () => {
    try {
      socket.emit("getprofile");

      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest("me", "GET", null, headers);

      setUser(res.data);

      if (res.data) {
        await Allgames(res.data._id || res.data.id);
      }
    } catch (error) {
      console.error("Transaction history profile error:", error);
    }
  };

  // ========================================
  // TRANSACTION HISTORY API
  // ========================================

  const Allgames = async (id) => {
    if (!id) return;

    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    setIsLoading(true);

    try {
      const res = await apiRequest(
        `temp/deposite/${id}?page=${pageNumber}&_limit=${limit}`,
        "GET",
        null,
        headers
      );

      setGame(res?.data?.ress || []);
      setNumberOfPages(res?.data?.totalPages || 0);
    } catch (error) {
      console.error("Transaction history API error:", error);
      setGame([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ========================================
  // PAGINATION
  // ========================================

  const handlePageClick = (data) => {
    const currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  useEffect(() => {
    role();

    // Existing pagination effect retained.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, limit]);

  // ========================================
  // DATE FORMAT
  // ========================================

  const dateFormat = (value) => {
    if (!value) return "—";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return "—";

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${formattedDate}, ${formattedTime}`;
  };

  // ========================================
  // TRANSACTION CARD DATA
  // ========================================

  const getTransactionDetails = (card) => {
    const status = String(card?.status || "").toLowerCase();
    const requestType = String(card?.Req_type || "").toLowerCase();

    let title = "";
    let sign = "";
    let statusType = "failed";
    let amountType = "debit";
    let statusLabel = card?.status || "Unknown";

    // Preserve existing transaction title/sign logic.

    if (
      (requestType === "deposit" || requestType === "bonus") &&
      status !== "failed"
    ) {
      title = "Cash Added";

      if (status === "pending" && requestType === "deposit") {
        sign = "-";
        amountType = "debit";
      } else {
        sign = "+";
        amountType = "credit";
      }
    } else if (requestType === "withdraw" && status !== "failed") {
      title = `Withdraw using ${card?.Withdraw_type || "Wallet"}`;
      sign = "-";
      amountType = "debit";
    } else if (requestType === "penalty" && status !== "failed") {
      title = "Penalty";
      sign = "-";
      amountType = "debit";
    } else if (status === "pending" || status === "failed") {
      title = "FAILED";
      sign = "×";
      amountType = "debit";
    } else {
      title = card?.Req_type || "Transaction";
      sign = "+";
      amountType = "credit";
    }

    // Status styling.

    if (
      status === "success" ||
      status === "successful" ||
      status === "completed"
    ) {
      statusType = "success";
      statusLabel = "Success";
    } else if (
      status === "pending" ||
      status === "none" ||
      status === "processing"
    ) {
      statusType = "pending";
      statusLabel =
        status === "none" || status === "processing"
          ? "Processing"
          : "Pending";
    } else {
      statusType = "failed";

      if (status === "failed") {
        statusLabel = "Failed";
      }
    }

    // Keep existing pending-deposit / pending-withdraw processing display.

    if (
      status === "pending" &&
      (requestType === "deposit" || requestType === "withdraw")
    ) {
      statusType = "pending";
      statusLabel = "Processing";
    }

    return {
      title,
      sign,
      statusType,
      statusLabel,
      amountType,
    };
  };

  // ========================================
  // ORDER ID
  // ========================================

  const getOrderId = (id) => {
    if (!id) return "—";

    const timestamp = String(id).slice(0, 8);

    const parsedTimestamp = parseInt(timestamp, 16);

    return Number.isNaN(parsedTimestamp) ? "—" : parsedTimestamp;
  };

  // ========================================
  // CLOSING BALANCE
  // ========================================

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") {
      return "0.00";
    }

    const amount = Number(value);

    return Number.isFinite(amount)
      ? amount.toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
      : value;
  };

  // ========================================
  // RENDER
  // ========================================

  return (
    <div className="mlk-txn-history">

      {/* LOADING */}

      {isLoading && (
        <div className="mlk-txn-loading">
          <img
            src="/images/LandingPage_img/loader1.gif"
            alt="Loading transactions"
          />
          <p>Loading transaction history...</p>
        </div>
      )}

      {/* EMPTY STATE */}

      {!isLoading && cardData && cardData.length === 0 && (
        <div className="mlk-txn-empty">
          <div className="mlk-txn-empty-icon">
            <MdOutlineReceiptLong />
          </div>

          <h3>No Transaction History</h3>

          <p>You have not made any transaction yet.</p>
        </div>
      )}

      {/* TRANSACTION LIST */}

      {!isLoading && cardData && cardData.length > 0 && (
        <div className="mlk-txn-list">

          {cardData.map((card, index) => {
            const {
              title,
              sign,
              statusType,
              statusLabel,
              amountType,
            } = getTransactionDetails(card);

            const orderId = getOrderId(card?._id);

            const isWithdrawal =
              String(card?.Req_type || "").toLowerCase() === "withdraw";

            const isCredit = amountType === "credit";

            const isSelected = selectedCardId === card?._id;

            const formattedDate = dateFormat(card?.createdAt).split(",");

            return (
              <>
                {cardData &&
                  cardData.map((card, index) => {
                    const reqType = String(card?.Req_type || "").toLowerCase();
                    const status = String(card?.status || "").toLowerCase();

                    // Transaction status
                    const isProcessing =
                      status === "none" || status === "pending";

                    const isFailed =
                      status === "failed" || status === "failure";

                    const isSuccess = status === "success";

                    const statusType = isProcessing
                      ? "pending"
                      : isFailed
                        ? "failed"
                        : isSuccess
                          ? "success"
                          : "pending";

                    const statusLabel = isProcessing
                      ? "PROCESSING"
                      : isFailed
                        ? "FAILED"
                        : isSuccess
                          ? "SUCCESS"
                          : String(card?.status || "PROCESSING").toUpperCase();

                    // Transaction title
                    let title = "Transaction";
                    let image = "/images/transaction-default.png";
                    let isCredit = false;

                    switch (reqType) {
                      case "deposit":
                        title = "Deposit";
                        image = "/images/status-deposit.png";
                        isCredit = isSuccess;
                        break;

                      case "withdraw":
                        title = `Withdraw${card?.Withdraw_type ? ` using ${card.Withdraw_type}` : ""}`;
                        image = "/images/status-withdraw.png";
                        isCredit = false;
                        break;

                      case "bonus":
                        title = "Bonus";
                        image = "/images/status-bonus.png";
                        isCredit = isSuccess;
                        break;

                      case "redeem":
                        title = "Redeem";
                        image = "/images/status-redeem.png";
                        isCredit = isSuccess;
                        break;

                      case "penalty":
                        title = "Penalty";
                        image = "/images/status-penalty.png";
                        isCredit = false;
                        break;

                      default:
                        title = reqType
                          ? reqType.charAt(0).toUpperCase() + reqType.slice(1)
                          : "Transaction";
                        break;
                    }

                    // Failed transaction image takes priority
                    if (isFailed) {
                      image = "/images/status-failed.png";
                    }

                    // Preserve old transaction sign logic
                    let sign = "+";

                    if (
                      reqType === "withdraw" ||
                      reqType === "penalty" ||
                      (reqType === "deposit" && isProcessing)
                    ) {
                      sign = "-";
                    } else if (isFailed) {
                      sign = "×";
                    }

                    const amount = Number(card?.amount) || 0;
                    const closingBalance = Number(card?.closing_balance);
                    const formattedDate = dateFormat(card?.createdAt).split(",");

                    const orderId = card?._id || "—";
                    const isWithdrawal = reqType === "withdraw";
                    const isSelected = selectedCardId === card?._id;

                    return (
                      <article
                        className={`mlk-txn-card mlk-txn-${statusType}`}
                        key={card?._id || index}
                        style={{ "--mlk-txn-index": index }}
                      >
                        {/* CARD TOP */}
                        <div className="mlk-txn-card-top">

                          {/* LEFT: TRANSACTION IMAGE */}
                          <div className={`mlk-txn-artwork mlk-txn-artwork-${reqType || "default"}`}>
                            <span className="mlk-txn-artwork-glow" />

                            <img
                              src={image}
                              alt={title}
                              className="mlk-txn-artwork-image"
                              onError={(e) => {
                                e.currentTarget.style.visibility = "hidden";
                              }}
                            />

                            {/* <span className="mlk-txn-artwork-label">
                              {isFailed
                                ? "FAILED"
                                : isProcessing
                                  ? "PENDING"
                                  : reqType.toUpperCase()}
                            </span> */}
                          </div>

                          {/* MIDDLE DETAILS */}
                          <div className="mlk-txn-middle">

                            <div className="mlk-txn-title-row">
                              <h3 className="mlk-txn-title">{title}</h3>

                              <span
                                className={`mlk-txn-status-badge mlk-txn-badge-${statusType}`}
                              >
                                {statusType === "success" ? (
                                  <FiCheckCircle />
                                ) : statusType === "pending" ? (
                                  <FiClock />
                                ) : (
                                  <FiXCircle />
                                )}

                                {statusLabel}
                              </span>
                            </div>

                            {/* <div className="mlk-txn-detail">
                              <span className="mlk-txn-detail-icon">
                                <MdOutlineReceiptLong />
                              </span>

                              <div className="mlk-txn-detail-copy">
                                <span className="mlk-txn-label">Order ID</span>

                                <strong className="mlk-txn-order-id">
                                  {orderId}
                                </strong>
                              </div>
                            </div> */}


                            {card?.txn_msg && (
                              <div className="mlk-txn-message">
                                <p>{card.txn_msg}</p>
                              </div>
                            )}
                            {/* <div className="mlk-txn-detail">
                              <span className="mlk-txn-detail-icon">
                                <FiCreditCard />
                              </span>

                              <div className="mlk-txn-detail-copy">
                                <span className="mlk-txn-label">Request Type</span>

                                <strong className="mlk-txn-request-type">
                                  {card?.Req_type || "—"}
                                </strong>
                              </div>
                            </div> */}

                          </div>

                          {/* DIVIDER */}
                          <div className="mlk-txn-divider" />

                          {/* RIGHT DETAILS */}
                          <div className="mlk-txn-right">

                            <div className="mlk-txn-amount-block">
                              <span className="mlk-txn-label">
                                Amount
                              </span>

                              <div
                                className={`mlk-txn-amount ${isCredit ? "mlk-txn-credit" : "mlk-txn-debit"
                                  }`}
                              >
                                <span className="mlk-txn-sign">{sign}</span>

                                <span>₹{formatAmount(amount)}</span>
                              </div>
                            </div>

                            {/* CLOSING BALANCE */}
                            <div className="mlk-txn-balance-block">
                              <span className="mlk-txn-balance-icon">
                                <MdOutlineAccountBalanceWallet />
                              </span>

                              <div className="mlk-txn-detail-copy">
                                <span className="mlk-txn-label">
                                  Closing Balance
                                </span>

                                <strong className="mlk-txn-balance">
                                  ₹
                                  {Number.isFinite(closingBalance)
                                    ? formatAmount(closingBalance)
                                    : "0.00"}
                                </strong>
                              </div>




                            </div>

                            <div className="mlk-txn-date">
                              {/* <FiCalendar /> */}

                              <span>{formattedDate[0] || "—"}</span>

                              {formattedDate[1] && (
                                <span className="mlk-txn-time">
                                  @ {formattedDate[1].trim()}
                                </span>
                              )}
                            </div>

                            {/* WITHDRAWAL DETAILS */}
                            {isWithdrawal && (
                              <div className="mlk-txn-eye-wrapper">
                                <button
                                  type="button"
                                  className={`mlk-txn-eye ${isSelected ? "is-active" : ""
                                    }`}
                                  onClick={() =>
                                    setSelectedCardId((previous) =>
                                      previous === card?._id ? null : card?._id
                                    )
                                  }
                                  aria-label="View withdrawal details"
                                  aria-expanded={isSelected}
                                >
                                  <BsFillEyeFill />

                                  <span>
                                    {isSelected ? "Hide Details" : "View Details"}
                                  </span>
                                </button>

                                {isSelected && (
                                  <div className="mlk-txn-payment-popup">
                                    {card?.upiId ? (
                                      <p>
                                        <strong>UPI ID:</strong> {card.upiId}
                                      </p>
                                    ) : (
                                      <>
                                        <p>
                                          <strong>Account Number:</strong>{" "}
                                          {card?.account_number || "—"}
                                        </p>

                                        <p>
                                          <strong>IFSC Code:</strong>{" "}
                                          {card?.ifsc_code || "—"}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}

                          </div>
                        </div>

                        {/* TRANSACTION MESSAGE */}
                        {/* {card?.txn_msg && (
                          <div className="mlk-txn-message">
                            <span className="mlk-txn-message-dot" />

                            <p>{card.txn_msg}</p>
                          </div>
                        )} */}

                        {/* FOOTER */}
                        {/* <div className="mlk-txn-footer">
                          <div className="mlk-txn-date">
                            <FiCalendar />

                            <span>{formattedDate[0] || "—"}</span>

                            {formattedDate[1] && (
                              <span className="mlk-txn-time">
                                @ {formattedDate[1].trim()}
                              </span>
                            )}
                          </div>

                          <span className="mlk-txn-footer-arrow">
                            <FiArrowRight />
                          </span>
                        </div> */}

                      </article>
                    );
                  })}
              </>
            );
          })}

        </div>
      )}

      {/* PAGINATION STATE RETAINED */}

      {numberOfPages > 1 && (
        <div className="mlk-txn-pagination-info">
          <span>
            Page {pageNumber} of {numberOfPages}
          </span>
        </div>
      )}

      {/* EXISTING WITHDRAWAL MODAL STATE RETAINED */}

      <Modal
        show={showBottom}
        onHide={handleCloseBottom}
        centered
        dialogClassName="mlk-txn-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>Withdrawal Details</Modal.Title>
        </Modal.Header>

        <Modal.Body className="mlk-txn-modal-body">

          {Withdrawal?.Withdraw_type === "banktransfer" && (
            <div className="mlk-txn-modal-details">
              <div>
                <span>Payment Method</span>
                <strong>Bank Transfer</strong>
              </div>

              <div>
                <span>Account Number</span>
                <strong>
                  {Withdrawal?.account_number || "—"}
                </strong>
              </div>

              <div>
                <span>IFSC Code</span>
                <strong>
                  {Withdrawal?.ifsc_code || "—"}
                </strong>
              </div>

              <div>
                <span>UTR</span>
                <strong>
                  {Withdrawal?.referenceId || "—"}
                </strong>
              </div>
            </div>
          )}

          {Withdrawal?.Withdraw_type === "Upi" && (
            <div className="mlk-txn-modal-details">
              <div>
                <span>Payment Method</span>
                <strong>UPI Transfer</strong>
              </div>

              <div>
                <span>UPI ID</span>
                <strong>
                  {Withdrawal?.upi_no || "—"}
                </strong>
              </div>
            </div>
          )}

          <div className="mlk-txn-modal-details">
            <div>
              <span>Status</span>
              <strong>{Withdrawal?.status || "—"}</strong>
            </div>

            <div>
              <span>Request Time</span>
              <strong>
                {dateFormat(Withdrawal?.createdAt)}
              </strong>
            </div>

            <div>
              <span>Processed Time</span>
              <strong>
                {dateFormat(Withdrawal?.updatedAt)}
              </strong>
            </div>
          </div>

          <div className="mlk-txn-modal-note">
            नोट: यदि आपका Withdrawal स्टेटस Pending दिखा रहा है, तो
            कृपया कुछ समय इंतज़ार करें। समस्या बनी रहने पर Support
            पेज से संपर्क करें।
          </div>

        </Modal.Body>
      </Modal>

    </div>
  );
};

export default Transactionhistory;